<div class="d-flex">
	<div class="ms-auto">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]="true"
			[hideDelete]="true"
			[hideSave]="false"
			(onSaveChange)="save()"
			[saveDisabled]="!changesToSave"
		></app-record-control-footer>
	</div>
</div>
<p-divider></p-divider>
<div class="p-grid" *ngIf="laborSetup">
	<div class="p-col-12 p-sm-6">
		<div class="d-flex">
			<div class="display-6 ms-1 mt-2 mb-1">Labor Rules</div>
		</div>
		<p-divider></p-divider>
		<app-employee-scheduling-setup-global-rules
			[(laborSetup)]="laborSetup"
			(changesToSaveChange)="changesToSave = $event"
		></app-employee-scheduling-setup-global-rules>
	</div>
	<div class="p-col-12 p-sm-6">
		<div class="d-flex">
			<div class="display-6 ms-1 mt-2 mb-1">Job Specific Rules</div>
			<div class="ms-auto">
				<app-record-control-footer
					[hideAdd]="false"
					[hideCancel]="true"
					[hideDelete]="true"
					[hideSave]="true"
					(onAddChange)="newJobRule()"
				></app-record-control-footer>
			</div>
		</div>
		<p-divider></p-divider>
		<ng-container *ngFor="let jobRule of laborSetup.jobSpecificRules">
			<app-employee-scheduling-setup-job-rule
				[jobRule]="jobRule"
				(jobRuleChange)="updateJobRule($event)"
				(jobRuleDeleteChange)="deleteJobRule($event)"
				(changesToSaveChange)="updateJobRule($event)"
			></app-employee-scheduling-setup-job-rule>
		</ng-container>
	</div>
</div>

<p-dialog [(visible)]="addJobRule" [breakpoints]="{ '960px': '25vw', '640px': '50vw' }" [style]="{ width: '25vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'scale-balanced']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">Add Job Rule</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<ng-template pTemplate="content">
		<div>
			<span class="p-float-label mt-4">
				<p-dropdown
					#jobRuleJobSelect
					[options]="jobList"
					optionLabel="name"
					optionValue="id"
					name="jobRuleJobSelect"
					[(ngModel)]="jobRule.jobId"
					(ngModelChange)="validateJobSelection()"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					itemSize="30"
					filter="true"
					(filterBy)="app.keys(jobList)"
				></p-dropdown>
				<label for="jobRuleJobSelect">Job</label>
			</span>
		</div>
		<ng-container *ngIf="invalidJobSelection">
			<small class="text-italics text-danger">Selected job has an existing Job Specific Rule.</small>
		</ng-container>
	</ng-template>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="cancelNewJobRule()"
			(onSaveChange)="addNewJobRule()"
			[cancelDisabled]="false"
			[saveDisabled]="!jobRule.jobId || invalidJobSelection"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
